const BASE = {
  getUserObject: "/api/v1/user",
  isLoggedIn: "/api/v1/isLoggedIn"
};

export default BASE;
